module.exports = __webpack_public_path__ + "static/media/danger.9ef0bbe0.svg";